import type { ReactNode } from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type StatusTone = "green" | "yellow" | "red" | "blue";

const toneClasses: Record<StatusTone, string> = {
  green: "bg-success-fade text-success-dark",
  yellow: "bg-warning-fade text-warning-dark",
  red: "bg-destructive-fade text-destructive-dark",
  blue: "bg-primary-fade text-primary"
};

/** Ersatz für .badge/.badge-green/-yellow/-red/-blue aus src/styles/base.css. */
export function StatusBadge({
  tone,
  icon,
  children,
  className
}: {
  tone: StatusTone;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Badge variant="outline" className={cn("gap-1 border-transparent font-bold tracking-wide uppercase", toneClasses[tone], className)}>
      {icon}
      {children}
    </Badge>
  );
}
